// Shared donor cell for every recon screen (subscriptions list + Tx reconciliation, all PSPs). Renders the
// donor name as a hyperlink to that devotee's profile (/devotees/:id) when a customer_id is known (the
// mapped devotee), otherwise as plain text. Opens in a new tab so the recon context isn't lost.
import React from 'react';
import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function DonorLink({ name, customerId, variant = 'body2', fontWeight = 500, sx }) {
  const label = name || '—';
  if (customerId && name) {
    return (
      <Link component={RouterLink} to={`/devotees/${customerId}`} target="_blank" rel="noopener"
        variant={variant}
        sx={{ fontWeight, color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, ...sx }}>
        {label}
      </Link>
    );
  }
  return <Typography variant={variant} sx={{ fontWeight, ...sx }}>{label}</Typography>;
}
